import type { CdnAgent, CdnShop } from '../../../types';

export function costAsPercent(
  entity: CdnAgent | CdnShop | { costRate?: string | number; cost_rate?: string | number },
): string {
  const raw =
    'costRate' in entity && entity.costRate !== undefined
      ? entity.costRate
      : (entity as { cost_rate?: string | number }).cost_rate;
  const n = raw === undefined || raw === null ? 0 : Number(raw);
  if (Number.isNaN(n)) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  }).format(n);
}

export function percentInputToRate(percentStr: string): number {
  const pct = parseFloat(percentStr);
  if (!Number.isFinite(pct)) return 0;
  const clamped = Math.min(100, Math.max(0, pct));
  const rate = clamped / 100;
  // Match backend DECIMAL(5,4) for shops.cost_rate
  return Math.round(rate * 10000) / 10000;
}

export function rateToPercentInput(rate: string | number | undefined | null): string {
  const n = rate === undefined || rate === null ? 0 : Number(rate);
  if (Number.isNaN(n)) return '0';
  return String((n * 100).toFixed(4).replace(/\.?0+$/, '') || '0');
}

/** Mirrors backend `normalizeCostRate` (packages/backend utils/costRate). */
export function normalizeCostRate(raw: string | number | undefined | null): number {
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) return 0;
  const capped = Math.min(n, 1);
  return Math.round(capped * 10000) / 10000;
}

/**
 * Mirrors backend `assertChildRateAboveParent` — child must be ≥ parent (4dp, epsilon).
 * Use for admin forms before submit; server remains authoritative.
 */
export function isChildCostRateValid(
  parentRate: string | number | undefined | null,
  childRate: string | number | undefined | null,
): boolean {
  const np = normalizeCostRate(parentRate);
  const nc = normalizeCostRate(childRate);
  return nc + 0.00001 >= np;
}
